/*
* 项目分享相关（现阶段只有微信分享调用了）
* */


//分享成功
export function shareSuccess() {

}